import React from 'react';
type ActionButtonProps = {
  variant?: 'primary' | 'go' | 'outline' | 'text';
  onClick: () => void;
  disabled?: boolean;
  children: React.ReactNode;
};
const BASE = 'inline-flex items-center justify-center whitespace-nowrap rounded-full font-medium transition-[background-color,color,border-color,transform] duration-150 ease-out active:scale-[0.97] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-accent disabled:pointer-events-none disabled:opacity-40';
const VARIANTS = {
  primary: 'bg-ink px-6 py-3 text-sm text-white hover:bg-accent',
  go: 'bg-accent px-10 py-4 text-base text-white hover:bg-ink',
  outline: 'border border-ink px-7 py-3.5 text-sm text-ink hover:bg-ink hover:text-white',
  text: 'px-2 py-3 text-sm text-graphite hover:text-ink'
};
export function ActionButton({
  variant = 'primary',
  onClick,
  disabled,
  children
}: ActionButtonProps) {
  return <button type="button" onClick={onClick} disabled={disabled} className={`${BASE} ${VARIANTS[variant]}`} data-id="element-5" data-mp="5wbb3x7jo8nz">
      {children}
    </button>;
}